import usePrinters from './usePrinters';
import { PaperSize } from '../services/exports/Constants';

/**
 * `pageWidth` — width, in printer dots, the receipt DOM must be rendered at before it is
 * screenshotted. External printers report their real head width (e.g. 576 dots for
 * 80mm); the Sunmi inner printer is fixed at PaperSize.Default (384 dots / 58mm).
 *
 * `isWidePaper` — the roll is wider than the Sunmi default, so the receipt has room to
 * step its type up. Lives here rather than in each receipt so both stay in agreement.
 */
export default function usePaperWidth() {
  const { defaultPrinter, printsExternally } = usePrinters();

  const externalWidth = Number(defaultPrinter?.settings?.paper_width_dots);

  function resolvePageWidth() {
    // No viewport downscale here — the receipt is position:fixed off-screen, so it can
    // exceed the viewport, and the external head width must be honoured exactly.
    if (printsExternally && externalWidth > 0) {
      return externalWidth;
    }

    return window.innerWidth < PaperSize.Default
      ? window.innerWidth * (window.innerWidth / PaperSize.Default)
      : PaperSize.Default;
  }

  const pageWidth = resolvePageWidth();

  // No useMemo: both callers destructure the primitives on the spot, so this object's identity
  // is never observed. Memoize it if anyone ever holds it whole and puts it in a dependency array.
  return { pageWidth, isWidePaper: pageWidth > PaperSize.Default };
}
